export default {
    methods: {
        getTotalDuration(intervals) {
            let totalMinutes = 0;
            intervals.forEach(item => {
                if (item.start && item.end) {
                    const startMinutes = (parseInt(item.start.split(':')[0]) * 60) + parseInt(item.start.split(':')[1])
                    const endMinutes = (parseInt(item.end.split(':')[0]) * 60) + parseInt(item.end.split(':')[1])
                    if (startMinutes > endMinutes) {
                        totalMinutes += ((24 * 60) - startMinutes) + endMinutes;
                    } else {
                        totalMinutes += (endMinutes - startMinutes);
                    }
                }
            })

            if (totalMinutes === 0) {
                return false;
            }

            let hours = Math.floor(totalMinutes / 60);
            let minutes = totalMinutes % 60;

            return hours.toString().padStart(2, '0') + '.' + minutes.toString().padStart(2, '0') + ' Hrs';
        },
    }
}
